import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import config from 'utils/config';
import { isMultiDomains } from 'utils/isMultiDomain';
import { hasPrivilege, isTeamManagerAndNotAdmin, PLAYLIST_WRITE } from 'utils/privileges';
import { getDistributedInfo } from 'screens/SinglePlaylistManager';
import InlineList from 'components/InlineList';
import PlaylistDropdown from 'components/ParentPlaylistDropdown';
import TextPlaceholder from 'components/TextPlaceholder';
import Box from 'components/Box';
import { getAudienceText } from '../../utils/getAudienceText';
import { ExternalDomainLink } from '../ExternalDomainLink';
function PlaylistHeaderSubtitle(_ref) {
  var _ref$showAccessTab = _ref.showAccessTab,
    showAccessTab = _ref$showAccessTab === void 0 ? true : _ref$showAccessTab,
    tabLinks = _ref.tabLinks,
    playlist = _ref.playlist;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isPlaylistAdmin = hasPrivilege(PLAYLIST_WRITE);
  if (!playlist) {
    return /*#__PURE__*/React.createElement(Box, {
      fontSize: "s"
    }, /*#__PURE__*/React.createElement(TextPlaceholder, {
      width: 140
    }));
  }
  var id = playlist.id,
    isDeleted = playlist.isDeleted,
    originatingId = playlist.originatingId,
    domain_id = playlist.domain_id,
    _playlist$parentPlayl = playlist.parentPlaylists,
    parentPlaylists = _playlist$parentPlayl === void 0 ? [] : _playlist$parentPlayl,
    sourceDomain = playlist.sourceDomain,
    _playlist$teamIds = playlist.teamIds,
    teamIds = _playlist$teamIds === void 0 ? [] : _playlist$teamIds,
    audience = playlist.audience,
    ownerTeamId = playlist.ownerTeamId,
    allow_member_contributions = playlist.allow_member_contributions;
  var canUserContribute = config.memberContributions && allow_member_contributions;
  var userIsTeamManagerAndNotAdmin = isTeamManagerAndNotAdmin({
    domain_id: domain_id,
    ownerTeamId: ownerTeamId
  });
  var isDistributed = isMultiDomains([domain_id]);
  var parentPlaylistCount = parentPlaylists.length;
  var _getDistributedInfo = getDistributedInfo({
      sourceDomain: sourceDomain,
      id: id,
      originatingId: originatingId,
      contentType: 'playlist'
    }),
    sourceUrl = _getDistributedInfo.sourceUrl,
    hubName = _getDistributedInfo.hubName;
  return /*#__PURE__*/React.createElement(Box, {
    dimmed: true,
    fontSize: "s"
  }, /*#__PURE__*/React.createElement(InlineList, {
    splitBy: "dot"
  }, isPlaylistAdmin && showAccessTab && getAudienceText({
    id: id,
    tabLinks: tabLinks,
    audience: audience,
    teamIds: teamIds,
    isDeleted: isDeleted
  }), (isPlaylistAdmin || userIsTeamManagerAndNotAdmin) && parentPlaylistCount && /*#__PURE__*/React.createElement(Trans, {
    t: t,
    i18nKey: 'hint_used_in_playlist',
    count: parentPlaylistCount
  }, 'Used in', ' ', /*#__PURE__*/React.createElement(PlaylistDropdown, {
    playlists: parentPlaylists
  }, "count playlists")), (canUserContribute || isPlaylistAdmin || userIsTeamManagerAndNotAdmin) && ownerTeamId && t('content_type_team_playlist'), isPlaylistAdmin && isDistributed && /*#__PURE__*/React.createElement(Trans, {
    t: t,
    i18nKey: "hint_distributed_from_hub_name",
    values: {
      hubName: hubName
    }
  }, 'Distributed from', ' ', /*#__PURE__*/React.createElement(ExternalDomainLink, {
    href: sourceUrl
  }, hubName))));
}
export default PlaylistHeaderSubtitle;